module.exports = __webpack_public_path__ + "a99c2af9515bf4fe3a38c8fb7023cd16.svg";